/** Second approval policy for processor costs: Automatic (needs 2+ Super Admins), Always, or Off. */
import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '../../lib/api';

const MODES = [['AUTO', 'Automatic', 'Required only once MSC has two or more Super Admins'], ['ON', 'Always', 'Someone else must approve every processor cost'], ['OFF', 'Off', 'You can approve your own processor costs']];

export function SecondApprovalCard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.request('/admin/settings/second-approval').then(setS).catch(() => {}); }, []);
  const set = async (mode) => {
    try { setS(await api.request('/admin/settings/second-approval', { method: 'PUT', body: JSON.stringify({ mode }) })); toast.success('Approval setting saved'); } catch (e) { toast.error(e.message || 'Could not save'); }
  };
  if (!s) return null;
  return (
    <div className="space-y-3 rounded-xl border bg-card p-5" data-testid="second-approval-card">
      <div><p className="font-semibold">Second approval for processor costs</p>
        <p className="text-xs text-muted-foreground" data-testid="second-approval-status">Right now: {s.required_now ? 'a second Super Admin must approve' : 'you can approve on your own'} · Super Admins: {s.super_admins.join(', ') || 'none'}</p></div>
      <div className="grid gap-2 sm:grid-cols-3">{MODES.map(([k, l, d]) => (
        <button key={k} type="button" onClick={() => set(k)} className={`rounded-lg border p-3 text-left text-sm ${s.mode === k ? 'border-primary ring-2 ring-primary/30' : 'hover:bg-muted'}`} data-testid={`second-approval-${k}`}>
          <p className="font-medium">{l}</p><p className="text-xs text-muted-foreground">{d}</p></button>))}</div>
    </div>
  );
}
